export enum StockStatus {
    Op_voorraad = 0,
    Beperkt = 1,
    Op_aanvraag = 2
}